import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import redCross from "../../../assets/images/CommonComponent/redCross.svg"
import greenPlus from "../../../assets/images/CommonComponent/greenPlus.svg"
import Select from "react-select";
import AppContainer from '../../../components/AppContainer/AppContainer';
import { useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import 'react-quill/dist/quill.snow.css';
import { Checkbox, CircularProgress } from '@mui/material';
import './AddEditAnnouncement.scss'
import { announcementGuestType, announcementVisibility } from '../../../Config/Constant';
import { EDIT } from '../../../utils/Helper';
import { addAnnouncement, getAnnouncementDetails, updateAnnouncement } from '../../../redux/actions/ContentManagementAction/AnnouncementsAction';

let defaultData ={
    "title": "",
    "description": "",
    "media": "",
    "media_type": "image",
    "media_thumbnail": "image",
    "redirect_lable": "",
    "redirect_page": "",
    "visible_to": "",
    "visible_program_type": "",
    "is_redirect_action": 0,
    "new_media": null
}
let validLinkRegex = /^(https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)|\/[Pp]rogram\/\d+)$/;
let removeSpaceRegex = /\s+/g;

const AddEditAnnouncement = (props) => {
    const { history, type } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [showBtns, setShowBtns] = useState();
    const [form, setForm]= useState(defaultData)
    const {updateLoader, loading, announcementDetails} = useSelector(state => state.announcementReducer);
    const [progress, setProgress] = useState(0);
    const announcementID = location?.state?.id;

    const setFormData=(key, value)=>{
        setForm(prev=>{
            let data={...prev}
            data[key]=value;
            return data
        })
    }
    
    const cancelPublish = (e) => {
        // if (type === EDIT) {
        //     setShowBtns(false);
        //     setForm(
        //         {
        //             "title": announcementDetails?.title || "",
        //             "description": announcementDetails?.description || "",
        //             "media": announcementDetails?.media || "",
        //             "media_url": announcementDetails?.media_url || "",
        //             "media_type": "image",
        //             "media_thumbnail": "image",
        //             "redirect_lable": announcementDetails?.redirect_lable || "",
        //             "redirect_page": announcementDetails?.redirect_page || "",
        //             "visible_to": announcementDetails?.visible_to || "",
        //             "visible_program_type": announcementDetails?.visible_program_type || "",
        //             "is_redirect_action": announcementDetails?.is_redirect_action || 0,
        //             "new_media": null
        //         }
        //     )
        // }else{
        // }
        navigate(-1);
    }

    const handleSubmit = (e) => {
        let bodyData ={
            ...form,
            redirect_page: (/^\/[Pp]rogram\/\d+$/).test(form.redirect_page) ? form.redirect_page?.toLowerCase() : form.redirect_page,
            visible_program_type: form.visible_to==='download_guest' ? 'all' : form.visible_program_type
        }
        if (type === EDIT) {
            dispatch(updateAnnouncement({
                ...bodyData,
                id: announcementID,
                onSuccessCallback:()=>{
                    navigate(-1)
                }
            }));
        } else {
            dispatch(addAnnouncement({
                ...bodyData,
                onSuccessCallback:()=>{
                    setForm(defaultData)
                }
            }));
        }
        
    }

    useEffect(() => {
        if (type === EDIT && announcementID) {
            const sendRequest = {
                "id": announcementID
            };
            dispatch(getAnnouncementDetails(sendRequest));
        }
    }, [])


    useEffect(() => {
        if (type === EDIT && announcementDetails) {
            setForm(
                {
                    "title": announcementDetails?.title || "",
                    "description": announcementDetails?.description || "",
                    "media": announcementDetails?.media || "",
                    "media_type": "image",
                    "media_thumbnail": "image",
                    "media_url": announcementDetails?.media_url || "",
                    "redirect_lable": announcementDetails?.redirect_lable || "",
                    "redirect_page": announcementDetails?.redirect_page || "",
                    "visible_to": announcementDetails?.visible_to || "",
                    "visible_program_type": announcementDetails?.visible_to==='download_guest' ? '' : announcementDetails?.visible_program_type || "",
                    "is_redirect_action": announcementDetails?.is_redirect_action || 0,
                    "new_media": null
                }
            )
        }
    }, [announcementDetails])

    useEffect(() => {
        const requiredFieldsFilled = form.title && form.visible_to && (form.visible_to==='download_guest' ? true : form.visible_program_type);
        if (!requiredFieldsFilled) return setShowBtns(false);

        const isEdit = type === EDIT;
        const hasChanges = isEdit
            ? (
                form.title !== announcementDetails?.title ||
                form.description !== announcementDetails?.description ||
                form.redirect_lable !== announcementDetails?.redirect_lable ||
                form.redirect_page !== announcementDetails?.redirect_page ||
                form.visible_to !== announcementDetails?.visible_to ||
                form.visible_program_type !== announcementDetails?.visible_program_type ||
                form.is_redirect_action !== announcementDetails?.is_redirect_action ||
                form.new_media
            )
            : form.new_media;

        if (!hasChanges) return setShowBtns(false);

        if (form.is_redirect_action === 1) {
            const validRedirect = form.redirect_lable && form.redirect_page && validLinkRegex.test(form.redirect_page);
            setShowBtns(!!validRedirect);
        } else {
            setShowBtns(true);
        }
    }, [form])

    return (
        <AppContainer history={history}>
            <div className="event-content">
                <div className='AddEditAnnouncement'>
                    {
                        loading && 
                        <div className='loader'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                    }
                    {
                        !loading &&
                        <div className="card">
                            <div className="card-header">
                                <h4>{type} Announcement</h4>
                                {showBtns && <div className='d-flex'>
                                    <button type="button" className="btn btn-danger redButton mr-3" onClick={cancelPublish} >
                                        <img className="mainIcon mr-2" src={redCross} alt="" width="16px" height="16px" />
                                        CANCEL
                                        </button>
                                    <button type="button" className="btn btn-success greenButton " onClick={handleSubmit} >
                                        {
                                            updateLoader ?
                                            <CircularProgress sx={{'color': '#31C52B'}} size={30}/>
                                            :
                                            <>
                                                <img className="mainIcon mr-2" src={greenPlus} alt="" width="16px" height="16px" />
                                                {type===EDIT ? 'UPDATE' : 'ADD'}
                                            </>
                                        }
                                    </button>
                                </div>}
                            </div>
                            <div className="separator"></div>
                            <div className="card-body p-4">
                                <div className='row cardDiv'>
                                    <div className='col'>
                                        <div className="col mb-2 dropDownsDiv">
                                            <div className="mb-3 pr-0 mr-3">
                                                <label htmlFor="exampleFormControlInput1" className="form-label Label">Title*</label>
                                                <input type="text" className="form-control Title" id="exampleFormControlInput1" placeholder="Enter title"
                                                    value={form.title}
                                                    autoComplete='off'
                                                    onChange={(e) => { setFormData("title", e.target.value) }}
                                                />
                                            </div>
                                            <div>
                                                <label htmlFor="floatingSelect" className="form-label Label">Visible To*</label>
                                                <Select
                                                    placeholder="Select "
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    onChange={(e) => { 
                                                        setFormData("visible_to", e.value); 
                                                        if(e.value==='download_guest'){
                                                            setFormData("visible_program_type", '');
                                                        } 
                                                    }}
                                                    value={form.visible_to ? announcementVisibility?.find(item=> item.value===form.visible_to): null}
                                                    options={announcementVisibility}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        isFocused: "#74613C",
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#F5F5F5',
                                                            primary: '#74613C',
                                                        },
                                                    })}

                                                />
                                            </div>
                                        </div>
                                        <div className="col mb-4 dropDownsDiv">
                                            <div>
                                                <label htmlFor="floatingSelect" className="form-label Label">Guest Type*</label>
                                                <Select
                                                    placeholder="Select "
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    onChange={(e) => { setFormData("visible_program_type", e.value) }}
                                                    value={form.visible_program_type ? announcementGuestType?.find(item=> item.value===form.visible_program_type): null}
                                                    options={announcementGuestType}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        isFocused: "#74613C",
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#F5F5F5',
                                                            primary: '#74613C',
                                                        },
                                                    })}
                                                    isDisabled={form.visible_to==='download_guest'}
                                                />
                                            </div>
                                            <div className='d-flex align-items-end ml-3 mb-2'>
                                                <div className='d-flex align-items-center'>
                                                    <Checkbox
                                                        checked={form.is_redirect_action===1}
                                                        onChange={(e) => { 
                                                            setFormData("is_redirect_action", e.target.checked ? 1 : 0) 
                                                            setFormData("redirect_lable", "") 
                                                            setFormData("redirect_page", "") 
                                                        }}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        size="small"
                                                    />
                                                    <div>Has Redirection</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='d-flex '>
                                            <div className="mb-3 pr-0">
                                                <label htmlFor="exampleFormControlInput1" className="form-label Label">Redirection Label</label>
                                                <input type="text" className="form-control Title" id="exampleFormControlInput1" placeholder="Enter "
                                                    autoComplete='off'
                                                    disabled={form.is_redirect_action===0}
                                                    value={form.redirect_lable}
                                                    onChange={(e) => { setFormData("redirect_lable", e.target.value) }}
                                                />
                                            </div>
                                            <div className="mb-2 ml-3 pr-0">
                                                <label htmlFor="exampleFormControlInput1" className="form-label Label">Redirection Link</label>
                                                <input type="text" className="form-control Title" id="exampleFormControlInput1" placeholder="Enter "
                                                    autoComplete='off'
                                                    disabled={form.is_redirect_action===0}
                                                    value={form.redirect_page}
                                                    onChange={(e) => { setFormData("redirect_page", e.target.value.replace(removeSpaceRegex, '')) }}
                                                />
                                                <div className='error-message'>
                                                    {
                                                        form.is_redirect_action===1 && !validLinkRegex.test(form.redirect_page) && form.redirect_page ?
                                                        <>Format should be https://site.com/ or /program/ID</>
                                                        :
                                                        <>&nbsp;</>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="mb-3 pr-0 w-100">
                                                <label htmlFor="exampleFormControlInput1" className="form-label Label">Description</label>
                                                <textarea className="form-control textArea" id="exampleFormControlTextarea1" rows="3" placeholder="Enter description"
                                                    value={form.description}
                                                    onChange={(e) => { setFormData("description", e.target.value) }}
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="mb-3 d-flex flex-column">
                                            <label htmlFor="exampleFormControlTextarea1" className="form-label Label" >Add Attachment*</label>
                                            <div>
                                                <label className='brownButton' htmlFor={`file-input`}>
                                                    Browse
                                                </label>
                                                <input
                                                    id={`file-input`}
                                                    type="file"
                                                    accept={"image/png, image/jpeg, image/svg"}
                                                    onChange={(e) => { setFormData("new_media", e.target.files[0]) }}
                                                    style={{ display: "none" }}
                                                    onClick={(e) => {
                                                        e.target.value = null;
                                                      }}
                                                />
                                                </div>
                                            {
                                                (form.new_media || form.media_url) &&
                                                <div className='mt-3  img-container'>
                                                    {form.new_media && <img className="mainIcon float-right mr-1" src={redCross} alt="" width="16px" height="16px" onClick={(e) => { setFormData("new_media", null)}} />}
                                                    <br/>
                                                    {/* <div className={`${updateLoader ? 'uploading': ''}`}> */}
                                                    <img 
                                                        className='media' 
                                                        src={form.new_media ? URL.createObjectURL(form.new_media) : form.media_url} 
                                                    />
                                                    {/* <div className='upload-loader'>
                                                        {updateLoader && <CircularProgressWithLabel  value={progress} height={30} width={30} fontSize={9} />}
                                                    </div>
                                                    </div> */}
                                                    <div className='pt-3'>
                                                    {form.new_media ? form.new_media.name : ''}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div >
            </div >
        </AppContainer >
    )
}



export default AddEditAnnouncement
